import { Row } from "@tanstack/react-table";

export function deviationAggregator(a: string, b: Row<any>[]) {
	const value = b.reduce((v, c) => {
		let current = c.getValue<number>(a);
		return v + current * current;
	}, 0);
	return Math.sqrt(value);
}
